import { CalendarEvent } from '@/models/undergrad/calendar-event.model';

export interface StudyCalendarEventState {
  studyCalendarEvents: CalendarEvent[];
  isLoadingStudyCalendarEventData: boolean;
}

const state: StudyCalendarEventState = {
  studyCalendarEvents: [],
  isLoadingStudyCalendarEventData: true,
};

export default state;
